const state = {
  views: {}, // {name: Component, name2: Component2}
  activeView: null, // Component(b-menu-view)

  // only for b-menu-item-actions needed
  editMode: false, // Boolean
  editItem: null, // {}
  hoverItem: null, // {}
  pagination: {
    page: 0
  }
}

export default state
